import type { FormulaConfig, FormulaConfigField } from '@/types'

export const RESULT_REFERENCE_NAME = 'result'
export const MISSING_REF_PLACEHOLDER = '—'

/** Source value used by AG Grid when formula handler updates cells. Guards against recursion. */
export const FORMULA_UPDATE_SOURCE = 'formulaUpdate'

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const isFormulaConfigField = (
  value: unknown,
): value is FormulaConfigField => {
  if (!isRecord(value)) return false
  return (
    typeof value.referenceName === 'string' &&
    value.referenceName.length > 0 &&
    typeof value.formula === 'string' &&
    (value.id === undefined || typeof value.id === 'string')
  )
}

export const isFormulaConfig = (value: unknown): value is FormulaConfig => {
  if (!isRecord(value)) return false
  if (!Array.isArray(value.fields) || !value.fields.every(isFormulaConfigField)) {
    return false
  }
  return isFormulaConfigField(value.formulaField)
}

export const parseFormulaConfig = (
  value: unknown,
): FormulaConfig | undefined => {
  if (isFormulaConfig(value)) return value
  if (typeof value !== 'string') return undefined
  try {
    const parsed: unknown = JSON.parse(value)
    return isFormulaConfig(parsed) ? parsed : undefined
  } catch {
    return undefined
  }
}

export const containsIncrementToken = (value?: string): boolean =>
  Boolean(value?.includes('{INC}') || value?.includes('increment'))

export const isMissingFormulaToken = (value: unknown): boolean =>
  value === undefined ||
  value === null ||
  String(value) === MISSING_REF_PLACEHOLDER
